export default class Credentials {
  constructor(data) {
    this.email = (data.email || '').toLowerCase().trim();
    this.password = data.password || '';
  }
  getEmail() {
    return this.email;
  }
  getPassword() {
    return this.password;
  }
}